<template>
  <div>
    <v-row class="mb-1">
      <v-col cols="12">
        <h3 class="font-weight-bold">
          {{ translation(translationList.building_type, 'Tip constructie') }}
        </h3>
        <p class="font-weight-regular">
          {{
            translation(translationList.building_type_helper, 'Alege tipul de construcție al locuinței tale.')
          }}
        </p>
      </v-col>
    </v-row>
    <div
        class="border-0 px-0 py-0 d-inline-flex w-100"
        v-if="buildingTypeList && buildingTypeList.length"
    >
      <div
          v-for="(buildingType, index) in buildingTypeList"
          :key="index"
          class="w-100"
      >
        <div
            class="px-5 py-2 cursor-pointer w-100 text-center border rounded-lg"
            @click="onTabChange(buildingType)"
            :class="buildingType.id === selectedBuildingType.id ? 'bg-secondary' : 'bg-secondary-accent'"
        >
          {{ buildingType.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref, watch, onMounted} from 'vue';
import {translation, useTranslationStore} from "~/plugins/store/translations";
import {type BuildingType} from '~/types/House';
import {useHouseStore} from "~/plugins/store/house";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => BuildingType,
      default: false,
    },
  },
  setup(props, {emit}) {
    const selectedBuildingType = ref<BuildingType>(props.modelValue);
    const translationList = ref<TranslationList>({});
    const buildingTypeList = ref<BuildingType[]>([]);
    const houseStore = useHouseStore();
    const translationStore = useTranslationStore();

    const onTabChange = (newValue: BuildingType) => {
      selectedBuildingType.value = newValue;
      emit('update:modelValue', newValue);
    };

    watch(() => props.modelValue, (newValue) => {
      selectedBuildingType.value = newValue;
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      buildingTypeList.value = await houseStore.getBuildingTypeList();
    });

    return {
      selectedBuildingType,
      onTabChange,
      translationList,
      translation,
      buildingTypeList
    };
  },
});
</script>

<style scoped>

</style>
